/** "1 day" / "3 days" — never "1 days" (UI review source pass). */
export const plural = (n: number, word: string, many = `${word}s`): string => `${n} ${n === 1 ? word : many}`;

/** "(in 15 days)" for a due date ahead — "today" on the day itself (UI review U115: never "15d"). */
export const inDays = (n: number): string => (n <= 0 ? 'today' : `in ${plural(n, 'day')}`);
